import React, { useState, useEffect } from "react";
import { Grid, Typography, CardContent } from "@mui/material";
import DetailsSection from "./EditableSection";
import "./PL.css";

const BasicDetails = ({ lead, onSave }) => {
  const [localLead, setLocalLead] = useState(lead);

  useEffect(() => {
    setLocalLead(lead); // Sync with parent updates
  }, [lead]);

  const fallback = (value) => value ?? "Not Provided";
  const random_id = localLead?.random_id;

  return (
    <>
      <Typography variant="h6" className="basic-details-title" gutterBottom>
        📑 Lead Information Overview
      </Typography>

      <Grid container>
        {/* Identity */}
        <CardContent>
          <DetailsSection
            title="Identity"
            icon="👤"
            data={{
              random_id,
              name: fallback(localLead?.name),
              dob: fallback(localLead?.dob),
              gender: fallback(localLead?.gender),
              monthly_income: fallback(localLead?.monthly_income),
              mobile_number: fallback(localLead?.mobile_number),
              email: fallback(localLead?.email),
              aadhar_no: fallback(localLead?.aadhar_no),
              pan_no: fallback(localLead?.pan_no),
            }}
            fields={[
              { name: "name", label: "Full Name" },
              { name: "dob", label: "Date of Birth" },
              { name: "gender", label: "Gender" },
              { name: "monthly_income", label: "Monthly Income" },
              { name: "mobile_number", label: "Mobile" },
              { name: "email", label: "Email" },
              { name: "aadhar_no", label: "Aadhaar No." },
              { name: "pan_no", label: "PAN No." },
            ]}
            onSave={onSave}
          />
        </CardContent>

        {/* Loan Request */}
        <CardContent>
          <DetailsSection
            title="Loan Request"
            icon="💰"
            data={{
              random_id,
              loan_type: fallback(localLead?.loan_type),
              req_loan_amt: fallback(localLead?.req_loan_amt),
              tenure: fallback(localLead?.tenure),
            }}
            fields={[
              { name: "loan_type", label: "Loan Type" },
              { name: "req_loan_amt", label: "Requested Amount" },
              { name: "tenure", label: "Tenure (Months)" },
            ]}
            onSave={onSave}
          />
        </CardContent>

        {/* Employment */}
        <CardContent>
          <DetailsSection
            title="Employment & Income"
            icon="💼"
            data={{
              random_id,
              employment: fallback(localLead?.employment),
              employer_name: fallback(localLead?.employer_name),
              work_location: fallback(localLead?.work_location),
            }}
            fields={[
              { name: "employment", label: "Employment Type" },
              { name: "employer_name", label: "Employer Name" },
              { name: "work_location", label: "Work Location" },
            ]}
            onSave={onSave}
          />
        </CardContent>

        {/* Current Address */}
        <CardContent>
          <DetailsSection
            title="Current Address"
            icon="🏠"
            data={{
              random_id,
              c_door: fallback(localLead?.c_door),
              c_town: fallback(localLead?.c_town),
              c_mandal: fallback(localLead?.c_mandal),
              c_district: fallback(localLead?.c_district),
              c_state: fallback(localLead?.c_state),
              c_pincode: fallback(localLead?.c_pincode),
            }}
            fields={[
              { name: "c_door", label: "Door / Locality" },
              { name: "c_town", label: "Village / Town" },
              { name: "c_mandal", label: "Mandal" },
              { name: "c_district", label: "District" },
              { name: "c_state", label: "State" },
              { name: "c_pincode", label: "Pincode" },
            ]}
            onSave={onSave}
          />
        </CardContent>

        {/* Permanent Address */}
        <CardContent>
          <DetailsSection
            title="Permanent Address"
            icon="📍"
            data={{
              random_id,
              p_door: fallback(localLead?.p_door),
              p_town: fallback(localLead?.p_town),
              p_mandal: fallback(localLead?.p_mandal),
              p_district: fallback(localLead?.p_district),
              p_state: fallback(localLead?.p_state),
              p_pincode: fallback(localLead?.p_pincode),
            }}
            fields={[
              { name: "p_door", label: "Door / Locality" },
              { name: "p_town", label: "Village / Town" },
              { name: "p_mandal", label: "Mandal" },
              { name: "p_district", label: "District" },
              { name: "p_state", label: "State" },
              { name: "p_pincode", label: "Pincode" },
            ]}
            onSave={onSave}
          />
        </CardContent>
      </Grid>
    </>
  );
};

export default BasicDetails;